import { apiSlice } from "../../app/api/apiSlice";

export const chatsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUnreadMessage: builder.query({
      query: () => ({
        url: "/chats/unread_msg",
      }),
      // Add keep-alive and retry logic
      keepUnusedDataFor: 60, // Keep data for 60 seconds
      extraOptions: {
        maxRetries: 3,
      },
    }),
    getChatId: builder.query({
      query: ({ id }) => ({
        url: `/chats/${id}`,
      }),
      providesTags: (_, __, arg) => [{ type: "Chat", id: arg?.id }],
    }),
    getChatsByCompany: builder.query({
      query: ({ page, per_page }) => ({
        url: `/chats/company/?page=${page}&per_page=${per_page}`,
        validateStatus: (response, result) => {
          // Accept all 200 responses, even if the data array is empty
          return response.status === 200 && !result.isError;
        },
      }),
      transformResponse: (response) => {
        // Ensure we always have a valid data structure even if data is empty
        return {
          data: response?.data || [],
          count: response?.count || 0,
          page: response?.page || 0,
          message: response?.message || ""
        };
      },
      providesTags: () => {
        return [{ type: "Chat", id: "LIST" }];
      },
    }),
    addNewChat: builder.mutation({
      query: (initialChat) => ({
        url: "/chats",
        method: "POST",
        body: {
          ...initialChat,
        },
      }),
      invalidatesTags: [{ type: "Chat", id: "LIST" }],
    }),
    createChatProcurementReq: builder.mutation({
      query: (initialChat) => ({
        url: "/chats/procurement_req",
        method: "POST",
        body: {
          ...initialChat,
        },
      }),
      invalidatesTags: [{ type: "Chat", id: "LIST" }],
    }),
    updateChat: builder.mutation({
      query: (initialChat) => ({
        url: "/chats",
        method: "PATCH",
        body: {
          ...initialChat,
        },
      }),
    }),
    deleteChat: builder.mutation({
      query: ({ id }) => ({
        url: `/chats`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (_, __, arg) => [{ type: "Chat", id: arg.id }],
    }),
    downloadChatPdf: builder.query({
      query: ({ offer_id }) => ({
        url: `/chats/download_pdf/?offer_id=${offer_id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUnreadMessageQuery,
  useGetChatIdQuery,
  useLazyGetChatsByCompanyQuery,
  useAddNewChatMutation,
  useUpdateChatMutation,
  useDeleteChatMutation,
  useCreateChatProcurementReqMutation,
  useLazyDownloadChatPdfQuery,
} = chatsApiSlice;
